import {
    SourceAppValues,
    UsageEventType,
    UsageLogEventValues,
    UsageLogTypesValues
} from '@/constants/usage';
import { getDeviceProps } from '@/lib/device';

export interface TrackUsageParams {
    sourceApp: SourceAppValues;
    subject: UsageLogTypesValues;
    action: UsageLogEventValues;
    type: UsageEventType;
    properties?: Record<string, string>;
    token?: string;
}

export async function trackUsage(params: TrackUsageParams): Promise<void> {
    try {
        const deviceProps = getDeviceProps();

        const body = JSON.stringify({
            SourceApp: params.sourceApp,
            Subject: params.subject,
            Action: params.action,
            Type: params.type,
            Properties: {
                ...(params.properties || {}),
                ...deviceProps
            }
        });

        // Call backend proxy endpoint instead of external service directly
        // Backend will handle authentication via cookies
        const response = await fetch('/api/usage', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include', // Include cookies for authentication
            body
        });

        if (!response.ok) {
            const text = await response.text();
            console.error(
                '[trackUsage] Request failed:',
                response.status,
                text
            );
        } else {
            const result = await response.json();
        }
    } catch (err) {
        console.error('[trackUsage] Failed to track usage:', err);
    }
}
